export default __webpack_public_path__ + "static/media/about-us.38496759.png";